import { actionTypes as dataFetchActionTypes } from '@buffer-mono/async-data-fetch'

import keyWrapper from '~publish/helpers/keywrapper'

import type { Profile } from './types'

export const actionTypes = keyWrapper('DISCONNECTED_PROFILES_MODAL', {
  RECONNECT_PROFILE: 0,
})

export type DisconnectedProfile = Profile & {
  disabled: boolean
  isDisconnected: boolean
  organizationId: string
}

export type DisconnectedProfilesModalState = {
  disconnectedProfiles: DisconnectedProfile[]
}

export const initialState: DisconnectedProfilesModalState = {
  disconnectedProfiles: [],
}

type DisconnectedProfilesAction = {
  type: string
  id?: string
  service?: string
  result?: Array<Omit<DisconnectedProfile, 'reconnecting'>>
}

const reducer = (
  state = initialState,
  action: DisconnectedProfilesAction,
): DisconnectedProfilesModalState => {
  switch (action.type) {
    case `profiles_${dataFetchActionTypes.FETCH_SUCCESS}`: {
      return {
        ...state,
        disconnectedProfiles: (action.result ?? [])
          .filter((profile) => profile.isDisconnected && !profile.disabled)
          .map((profile) =>
            Object.assign({}, profile, { reconnecting: false }),
          ),
      }
    }
    case actionTypes.RECONNECT_PROFILE:
      return {
        ...state,
        disconnectedProfiles: state.disconnectedProfiles.map((profile) => ({
          ...profile,
          reconnecting: profile.id === action.id,
        })),
      }
    default:
      return state
  }
}

export const actions = {
  reconnectProfile: ({
    id,
    service,
  }: Pick<Profile, 'id' | 'service'>): {
    type: 'DISCONNECTED_PROFILES_MODAL__RECONNECT_PROFILE'
    id: string
    service: string
  } => ({
    type: actionTypes.RECONNECT_PROFILE,
    id,
    service,
  }),
}

export default reducer
